export default "__VITE_ASSET__DG2ZVQ2x__"